<input type="time" class="form-control"
       [(ngModel)]="parsedValue"
       (ngModelChange)="update()">
